import React from "react";
import { Layout, Popover, Button, Avatar, Badge, message } from "antd";
import { UserOutlined, ExportOutlined } from "@ant-design/icons";
import { getAuth, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { logUserAction } from "../../../logs";
import { APP_VERSION } from "../../../utils";
import "./header.css";
import logo from "../../../assets/img/logo.png";

const { Header } = Layout;

export default function MainHeader() {
  const auth = getAuth();
  const db = getFirestore();

  const user = auth.currentUser?.email;

  const handleLogOut = async () => {
    await logUserAction(db, auth, "LOG_OUT", auth.currentUser.uid, null, null, APP_VERSION);
    await signOut(auth).then(() => {
      window.location.href = "/";
      message.success(`Sesión cerrada `);
      localStorage.removeItem("role");
      localStorage.removeItem("password");
      localStorage.removeItem("email");
    });
  };

  const content = (
    <div>
      <p>Logueado(a) como {user}</p>

      <Button className="btn-close" onClick={() => handleLogOut()}>
        <ExportOutlined />
        &nbsp;Cerrar Sesión
      </Button>
    </div>
  );

  return (
    <Header
      style={{
        padding: 0,
        position: "fixed",
        boxShadow: "0 10px 20px 0 rgb(0 0 0 / 10%)",
      }}
    >
      <div
        style={{
          background: "#001529",
          padding: "10px",
          width: "200px",
          textAlign: "center"
        }}
      >
        <img src={logo} className="appLogo" alt="logo" />
      </div>

      <div className="user_section">
        <span>
          <Popover placement="bottomRight" content={content}>
            <Badge dot={true}>
              <Avatar icon={<UserOutlined />} className="avatar-item" />
            </Badge>
          </Popover>
        </span>
      </div>
    </Header>
  );
}
